import { useCallback, useEffect, useMemo } from 'react';
import { createGlobalState } from 'react-hooks-global-state';
import useStorageContext from './useStorageContext';
const KEY_NAME = 'contacts';
const { useGlobalState } = createGlobalState({
    contacts: null
});
export default function useContacts() {
    const storage = useStorageContext();
    const [state, setState] = useGlobalState('contacts');
    useEffect(() => {
        if (state) {
            const str = JSON.stringify(state);
            storage.setItem(KEY_NAME, str);
            return;
        }
        const str = storage.getItem(KEY_NAME);
        if (str) {
            const cs = JSON.parse(str);
            setState(cs);
        }
        else {
            setState([]);
        }
    }, [setState, state, storage]);
    const addContact = useCallback(async (contact) => {
        if (!state) {
            setState([contact]);
            return;
        }
        if (state.find((c) => c.email === contact.email)) {
            return;
        }
        const updated = state.concat([contact]);
        setState(updated);
    }, [setState, state]);
    const removeContact = useCallback((contact) => {
        if (!state) {
            return;
        }
        const index = state.findIndex((c) => c.email === contact.email);
        if (index >= 0) {
            const updated = state.slice(0);
            updated.splice(index, 1);
            setState(updated);
        }
    }, [setState, state]);
    return useMemo(() => ({
        addContact,
        contacts: state,
        removeContact,
        setContacts: setState
    }), [addContact, removeContact, setState, state]);
}
